import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

interface UseNavigationReturn {
  handleCollectionClick: (collectionName: string) => void;
  handleApplicationClick: (applicationId: string) => void;
  handleManageCollections: () => void;
  handleManageApplications: () => void;
}

export const useNavigation = (): UseNavigationReturn => {
  const navigate = useNavigate();

  const handleCollectionClick = useCallback(
    (collectionName: string) => {
      window.scrollTo(0, 0);
      navigate(`/collections?search=${encodeURIComponent(collectionName)}`);
    },
    [navigate],
  );

  const handleApplicationClick = useCallback(
    (applicationId: string) => {
      navigate(`/applications?search=${encodeURIComponent(applicationId)}`);
    },
    [navigate],
  );

  const handleManageCollections = useCallback(() => {
    navigate('/collections');
  }, [navigate]);

  const handleManageApplications = useCallback(() => {
    navigate('/applications');
  }, [navigate]);

  return {
    handleCollectionClick,
    handleApplicationClick,
    handleManageCollections,
    handleManageApplications,
  };
};
